import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { httpService } from "../../../../services/httpService.service";
import { HOME_COLORS } from "../homeTheme";

// Red flag statuses (see Flags/Modals/AddRedFlagCardModal):
// 1 Not addressed, 2 In progress, 3 On hold, 4 Resolved, 5 Archived
// Colours come from the home palette so the panel reads as one muted family.
const FLAG_STATUS = {
  1: { text: "Not addressed", fill: HOME_COLORS.alert },
  2: { text: "In progress", fill: HOME_COLORS.warn },
  3: { text: "On hold", fill: HOME_COLORS.stalled },
  4: { text: "Resolved", fill: HOME_COLORS.ok },
  5: { text: "Archived", fill: HOME_COLORS.neutral },
};
const OPEN_STATUSES = [1, 2, 3];

const FlagsSummaryPanel = () => {
  const navigate = useNavigate();
  const projectID = localStorage.getItem("currentProjectID");
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectID) {
      setLoading(false);
      return;
    }
    httpService.get(
      `/api/RedFlag/getAllRedFlags?ProjectId=${projectID}&IgnorePagination=true`,
      (res) => {
        const tally = {};
        // Red flags carry their status in `flagStatus` (not `status`).
        (res?.data || []).forEach((f) => {
          const key = f?.flagStatus ?? f?.status ?? "default";
          tally[key] = (tally[key] || 0) + 1;
        });
        setCounts(tally);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [projectID]);

  if (loading) {
    return (
      <div className="homePanel">
        <div className="homePanelLoading">
          <Spin />
        </div>
      </div>
    );
  }

  const openCount = OPEN_STATUSES.reduce((sum, s) => sum + (counts[s] || 0), 0);
  const totalCount = Object.values(counts).reduce((a, b) => a + b, 0);
  const maxCount = Math.max(1, ...Object.keys(FLAG_STATUS).map((k) => counts[k] || 0));

  return (
    <div className="homePanel">
      <div className="homePanelHead">
        <h3>Flags</h3>
        <span className="homePanelLink" onClick={() => navigate("/project/flags?Flags")}>
          Open Flags board
        </span>
      </div>

      <div className="homeFlagsOpen" style={{ alignItems: "baseline", gap: 8 }}>
        <span className="homeFlagsOpenCount">{openCount}</span>
        <span className="homeFlagsOpenLabel">open flags</span>
        {totalCount > 0 && (
          <span style={{ marginLeft: "auto", fontSize: 12, color: "#909094" }}>
            {totalCount} total
          </span>
        )}
      </div>

      {/* One 6px row per status, count written on the right. No legend, no
          hover: every number in the panel is on screen. */}
      <div className="homeBarRows">
        {Object.keys(FLAG_STATUS).map((key) => {
          const count = counts[key] || 0;
          const pct = Math.round((count / maxCount) * 100);
          const s = FLAG_STATUS[key];
          return (
            <div
              key={key}
              className="homeBarRow"
              onClick={() => navigate("/project/flags?Flags")}
            >
              <div className="homeBarRowHead">
                <span className="homeBarRowLabel">
                  <span className="homeDot" style={{ background: s.fill }} />
                  {s.text}
                </span>
                <span className="homeBarRowValue">{count}</span>
              </div>
              <div className="homeBarTrack">
                <div
                  className="homeBarFill"
                  style={{ width: `${pct}%`, background: s.fill }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FlagsSummaryPanel;
